import React, { useEffect, useState } from "react";
import PageTitle from "../../../module/pageTitle";
import AdminTable from "../../../Component/adminTable";
import LabelInput from "../../../Component/labelInput";
import { InputField, Submitbtn } from "../../../Component";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../store";
import {
  deleteAuthor,
  getAuthorDetailsById,
  getAuthorList,
  updateAuthor,
  uploadAutorImage,
} from "../adminSlice";
import {
  containsNumber,
  containsStartsWithSpecialCharsOrStartsWithNumberOrWhiteSpace,
  hasWhiteSpace,
  length_Ten,
  startsWithSpace,
  validateIsFileImageType,
  validateNameWithoutSpace,
  validateValueWithoutSpace,
} from "../../../Utils/validators";
import {
  containsStartsWithSpecialCharsOrStartsWithNumberOrWhiteSpaceErrMsg,
  validateIsFileImageTypeErrMsg,
  validateIsNumberOnlyErrMsg,
  validUniqueName,
} from "../../../Utils/errorMsg";
import TextEditor from "../../../Component/textEditor";
import ImagePickerAndViewer from "../../../Component/imagePickerAndViewer";
import { showSnackbar, hideSnackbar } from "../../../store/slices/snackbarSlice";
const EditDeleteAuthor = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [isEditMode, setisEditMode] = useState<Boolean>(false);
  const [authorList, setAuthorList] = useState<any>([]);
  const [name, setName] = useState<any>("");
  const [designation, setDesignation] = useState<any>("");
  const [image, setImage] = useState<any>("");
  const [imageUpload, setImageUpload] = useState<any>("");
  const [about, setAbout] = useState<any>("");
  const [phoneNo, setPhoneNo] = useState<any>("");
  const [email, setEmail] = useState<any>("");
  const [linkedinURL, setLinkedinURL] = useState<any>("");
  const [facebookURL, setFacebookURL] = useState<any>("");
  const [instagramURL, setInstagramURL] = useState<any>("");
  const [googleURL, setGoogleURL] = useState<any>("");
  const [youtubeURL, setYoutubeURL] = useState<any>("");
  const [location, setLocation] = useState<any>("");
  const [uniqueName, setUniqueName] = useState<any>("");
  const [uniqueLink, setUniqueLink] = useState<any>("");
  const [authorId, setAuthorId] = useState<any>("");
  const [authorDetails, setAuthorDetails] = useState<any>("");
  const socialRegex = {
    emailPattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    youtube: /^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(@[a-zA-Z0-9._-]+|channel\/UC[a-zA-Z0-9_-]{22}|c\/[a-zA-Z0-9._-]+)|youtu\.be\/[a-zA-Z0-9_-]+)\/?$/,
    google: /^[a-zA-Z0-9._%+-]+@gmail\.com$/,
    instagram: /instagram\.com\/([a-zA-Z0-9._]+)/,
    linkedin: /(?:https?:\/\/)?(?:www\.)?linkedin\.com\/in\/([a-zA-Z0-9-]{3,100})/,
    facebook: /(?:https?:\/\/)?(?:www\.)?facebook\.com\/([a-zA-Z0-9.]{5,50})/,
  };
  useEffect(() => {
    getdata();
  }, []);

  const getdata = () => {
    dispatch(
      getAuthorList({
        callback: (res: any) => {
          if (res?.status === "success") {
            setAuthorList(res?.data);
            // dispatch(showSnackbar({ message: res?.msg, type: res?.type }));
            // setTimeout(() => {
            //   hideSnackbar();
            // }, 5000);
          }
        },
        errorCallback: () => { },
      })
    );
  };

  const onchangeName = (value: any) => {
    setName(value);
  };

  const onchangeDesignation = (value: any) => {
    setDesignation(value);
  };

  const handleChangeImg = (value: any) => {
    if (!validateIsFileImageType(value)) {
      return;
    } else {
      const reader = new FileReader();
      const file = value.target.files[0];
      const mediaTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg'];
      if (!mediaTypes.includes(file.type)) {
        console.error("Unsupported file type:", file.type);
        return;
      }
      reader.onloadend = () => {
        setImageUpload(reader.result);
      };
      dispatch(
        uploadAutorImage({
          params: file,
          callback: (res: any) => {
            if (res?.status === "success") {
              setImage(res?.data?.name);
            }
          },
          errorCallback: (error: any) => { },
        })
      );
      reader.readAsDataURL(file);
    }
  };

  const onchangeAbout = (value: any) => {
    setAbout(value);
  };

  const onchangePhoneNo = (value: any) => {
    if (value !== "") {
      if (!containsNumber(value)) {
        return;
      } else if (!validateValueWithoutSpace(value)) {
        return;
      } else {
        setPhoneNo(value);
      }
    } else {
      setPhoneNo(value);
    }
  };

  const onchangeEmail = (value: any) => {
    if (!startsWithSpace(value) && !hasWhiteSpace(value)) {
      setEmail(value);
    } else {
      return;
    }
  };

  const onchangeLinkedinURL = (value: any) => {
    setLinkedinURL(value);
  };
  const onchangeFacebookURL = (value: any) => {
    setFacebookURL(value);
  };
  const onchangeInstagramURL = (value: any) => {
    setInstagramURL(value);
  };
  const onchangeGoogleURL = (value: any) => {
    setGoogleURL(value);
  };
  const onchangeYoutubeURL = (value: any) => {
    setYoutubeURL(value);
  };
  const onchangeLocation = (value: any) => {
    setLocation(value);
  };
  const onchangeUniqueName = (value: any) => {
    if (containsStartsWithSpecialCharsOrStartsWithNumberOrWhiteSpace(value)) {
      return;
    } else if (!validateNameWithoutSpace(value)) {
      return;
    }
    setUniqueName(value);
  };
  const onchangeUniqueLink = (value: any) => {
    setUniqueLink(value);
  };

  const validations = () => {
    let valid = false;

    if (name === "" || designation === "" || about === "") {
      valid = true;
    }
    return valid;
  };

  const handleEdit = (value: any) => {
    setisEditMode(true);
    setAuthorId(value?._id);
    dispatch(
      getAuthorDetailsById({
        UniqueName: value?.uniqueName,
        callback: (res: any) => {
          setAuthorDetails(res?.data[0]);
          setName(res?.data[0]?.name);
          setDesignation(res?.data[0]?.designation);
          setImage(res?.data[0]?.image);
          setAbout(res?.data[0]?.about);
          setPhoneNo(res?.data[0]?.phoneNo);
          setEmail(res?.data[0]?.email);
          setLinkedinURL(res?.data[0]?.linkedIn);
          setFacebookURL(res?.data[0]?.facebook);
          setInstagramURL(res?.data[0]?.instagram);
          setGoogleURL(res?.data[0]?.google);
          setYoutubeURL(res?.data[0]?.youtube);
          setLocation(res?.data[0]?.location);
          setUniqueName(res?.data[0]?.uniqueName);
          setUniqueLink(res?.data[0]?.uniqueLink);
        },
        errorCallback: (error: any) => { },
      })
    );
  };
  const handleDelete = (value: any) => {
    setisEditMode(false);
    dispatch(
      deleteAuthor({
        id: value._id,
        callback: (res: any) => {
          if (res?.status === "success") {
            dispatch(showSnackbar({ message: "Author Delete SuccessFully", type: res?.status }));
            setTimeout(() => {
              hideSnackbar();
            }, 5000);
            getdata();
          }
        },
        errorCallback: () => {
          dispatch(showSnackbar({ message: "Author failed to delete", type: "error" }));
          setTimeout(() => {
            hideSnackbar();
          }, 5000);
        },
      })
    );
  };

  const handleUpdate = (e: any) => {
    e.preventDefault();
    if (validations()) {
      return;
    }
    if (!socialRegex?.emailPattern.test(email)) {
      dispatch(showSnackbar({ message: 'Invalid Email Address', type: 'error' }));
      setTimeout(() => {
        dispatch(hideSnackbar());
      }, 5000);
      return;
    }
    if (linkedinURL !== "") {
      if (!socialRegex?.linkedin.test(linkedinURL)) {
        dispatch(showSnackbar({ message: 'Invalid LinkedIn Id', type: 'error' }));
        setTimeout(() => {
          dispatch(hideSnackbar());
        }, 5000);
        return;
      }
    }
    if (facebookURL !== "") {
      if (!socialRegex?.facebook.test(facebookURL)) {
        dispatch(showSnackbar({ message: 'Invalid FaceBook Id', type: 'error' }));
        setTimeout(() => {
          dispatch(hideSnackbar());
        }, 5000);
        return;
      }
    }
    if (instagramURL !== "") {
      if (!socialRegex?.instagram.test(instagramURL)) {
        dispatch(showSnackbar({ message: 'Invalid Instagram Id', type: 'error' }));
        setTimeout(() => {
          dispatch(hideSnackbar());
        }, 5000);
        return;
      }
    }
    if (googleURL !== "") {
      if (!socialRegex?.google.test(googleURL)) {
        dispatch(showSnackbar({ message: 'Invalid Google Id', type: 'error' }));
        setTimeout(() => {
          dispatch(hideSnackbar());
        }, 5000);
        return;
      }
    }
    if (youtubeURL !== "") {
      if (!socialRegex?.youtube.test(youtubeURL)) {
        dispatch(showSnackbar({ message: 'Invalid YoutubeId', type: 'error' }));
        setTimeout(() => {
          dispatch(hideSnackbar());
        }, 5000);
        return;
      }
    }
    else {
      let matchAuthorImage = '';
      if (typeof image === 'string' && image.includes('/')) {
        matchAuthorImage = image.substring(image.lastIndexOf('/') + 1);
      }
      const postData: any = {
        image: matchAuthorImage != "" ? matchAuthorImage : image
      };
      if (authorDetails?.name !== name) {
        postData["name"] = name;
      }
      if (authorDetails?.designation !== designation) {
        postData["designation"] = designation;
      }
      if (authorDetails?.about !== about) {
        postData["about"] = about;
      }
      // if (authorDetails?.image !== image) {
      //   postData["image"] = resolvedImage;
      // }
      if (authorDetails?.phoneNo !== phoneNo) {
        postData["phoneNo"] = phoneNo;
      }
      if (authorDetails?.email !== email) {
        postData["email"] = email;
      }
      if (authorDetails?.linkedIn !== linkedinURL) {
        postData["linkedIn"] = linkedinURL;
      }
      if (authorDetails?.facebook !== facebookURL) {
        postData["facebook"] = facebookURL;
      }
      if (authorDetails?.instagram !== instagramURL) {
        postData["instagram"] = instagramURL;
      }
      if (authorDetails?.google !== googleURL) {
        postData["google"] = googleURL;
      }
      if (authorDetails?.youtube !== youtubeURL) {
        postData["youtube"] = youtubeURL;
      }
      if (authorDetails?.location !== location) {
        postData["location"] = location;
      }
      dispatch(
        updateAuthor({
          id: authorId,
          params: postData,
          callback: (res: any) => {
            if (res?.data?.status === "success") {
              setisEditMode(false);
              getdata();
              dispatch(showSnackbar({ message: "Author Details Updated Successfully", type: res?.data?.status }));
              setTimeout(() => {
                hideSnackbar();
              }, 5000);
            }
          },
          errorCallback: (error: any) => {
            dispatch(showSnackbar({ message: error?.data?.msg, type: error?.data?.type }));
            setTimeout(() => {
              hideSnackbar();
            }, 5000);
          },
        })
      );
    }
  };
  const handleGoBack = () => {
    setisEditMode(false);
  };
  const renderTable = () => {
    return (
      <div className="mt-4">
        <AdminTable
          tableData={authorList ? authorList : []}
          pagename={"Author"}
          tableHead={[
            "S.N",
            "Name",
            "Designation",
            "Unique Name",
            "Unique Link",
            "Action",
          ]}
          handleEdit={(value: any) => handleEdit(value)}
          handleDelete={(value: any) => handleDelete(value)}
          edit={true}
        />
      </div>
    );
  };
  const renderEditMode = () => {
    return (
      <form onSubmit={handleUpdate}>
        <div className="row ">
          <div className="col-md-4 mb-3">
            <LabelInput labelName={"Name"} isRequired />
            <InputField
              placeholder={"Enter Name"}
              setInputText={(value: any) => onchangeName(value)}
              value={name}
            />
          </div>
          <div className="col-md-4 mb-3">
            <LabelInput labelName={"Designation"} isRequired />
            <InputField
              placeholder={"Enter Designation"}
              setInputText={(value: any) => onchangeDesignation(value)}
              value={designation}
            />
          </div>
          <div className="col-md-4 mb-3">
            <LabelInput labelName={"Phone No."} isRequired />
            <InputField
              placeholder={"Enter Phone No."}
              setInputText={(value: any) => onchangePhoneNo(value)}
              value={phoneNo}
              maxLength={length_Ten}
              minLength={length_Ten}
            />
          </div>
          <div className="col-md-4 mb-3">
            <LabelInput labelName={"Email"} isRequired />
            <InputField
              placeholder={"Enter Email"}
              setInputText={(value: any) => onchangeEmail(value)}
              value={email}
            />
          </div>
          <div className="col-md-4 mb-3">
            <LabelInput labelName={"Linkedin URL"} />
            <InputField
              placeholder={"Enter Linkedin URL"}
              setInputText={(value: any) => onchangeLinkedinURL(value)}
              value={linkedinURL}
            />
          </div>
          <div className="col-md-4 mb-3">
            <LabelInput labelName={"Facebook URL"} />
            <InputField
              placeholder={"Enter Facebook URL"}
              setInputText={(value: any) => onchangeFacebookURL(value)}
              value={facebookURL}
            />
          </div>
          <div className="col-md-4 mb-3">
            <LabelInput labelName={"Instagram URL"} />
            <InputField
              placeholder={"Enter Instagram URL"}
              setInputText={(value: any) => onchangeInstagramURL(value)}
              value={instagramURL}
            />
          </div>
          <div className="col-md-4 mb-3">
            <LabelInput labelName={"Google URL"} />
            <InputField
              placeholder={"Enter Google URL"}
              setInputText={(value: any) => onchangeGoogleURL(value)}
              value={googleURL}
            />
          </div>
          <div className="col-md-4 mb-3">
            <LabelInput labelName={"Youtube URL"} />
            <InputField
              placeholder={"Enter Youtube URL"}
              setInputText={(value: any) => onchangeYoutubeURL(value)}
              value={youtubeURL}
            />
          </div>
          <div className="col-md-4 mb-3">
            <LabelInput labelName={"Location"} />
            <InputField
              placeholder={"Enter Location"}
              setInputText={(value: any) => onchangeLocation(value)}
              value={location}
            />
          </div>
          <div className="col-md-4 mb-3">
            <LabelInput labelName={"Unique Name"} />
            <InputField
              placeholder={"Enter Unique Name"}
              setInputText={(value: any) => onchangeUniqueName(value)}
              value={uniqueName}
              disabled
            />
          </div>
          <div className="col-md-4 mb-3">
            <LabelInput labelName={"Unique Link"} />
            <InputField
              placeholder={"Enter Unique Link"}
              setInputText={(value: any) => onchangeUniqueLink(value)}
              value={uniqueLink}
              disabled
            />
          </div>

          <div className="col-md-4 mb-3">
            <LabelInput labelName={"Image"} isRequired />
            <ImagePickerAndViewer
              value={imageUpload ? imageUpload : image}
              handleChange={(value: any) => handleChangeImg(value)}
              htmlFor={`backImage-upload-author`}
              doctype={""}
            />
          </div>
          <div className="col-md-12 mb-3">
            <LabelInput labelName={"About"} />
            <TextEditor
              onChange={(value: any) => onchangeAbout(value)}
              value={about}
            />
          </div>
          <div className="d-flex justify-content-center mt-3">
            <div className="col-md-2">
              <Submitbtn name={"Submit"} disabled={validations()} />
            </div>
          </div>
        </div>
      </form>
    );
  };
  return (
    <div className="panel-content">
      <div className="mb-4">
        <PageTitle
          name={"Edit / Delete Author"}
          breadCrumb={""}
          isEditMode={isEditMode}
          setisEditMode={setisEditMode}
          cancelEdit={() => handleGoBack()}
        />
      </div>
      <div className="formDiv">
        <div className="bxshadow p-2 borderRadius">
          {isEditMode ? renderEditMode() : renderTable()}
        </div>
      </div>
    </div>
  );
};

export default EditDeleteAuthor;
